import { ReactNode, RefObject, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Lockup } from './Lockup';
import { LangToggle, useI18n } from '../i18n';
import { useDocumentTitle } from './a11y';
import { useFocusFieldOrHeading } from './focus';

// The centred card used by the sign-in steps (role chooser, two-factor).
// Same look as the sign-in page's own frame.
export function AuthFrame({
  title,
  subtitle,
  focusField,
  wide,
  children,
}: {
  title: string;
  subtitle?: string;
  /** The step's one field: focused on arrival instead of the heading. */
  focusField?: RefObject<HTMLElement>;
  /** A wider card for reading (the staff notice). */
  wide?: boolean;
  children: ReactNode;
}) {
  const { t } = useI18n();
  const h1 = useRef<HTMLHeadingElement>(null);
  useDocumentTitle(title);
  useFocusFieldOrHeading(h1, focusField, title);
  return (
    <div className="login-page">
      <main className={`panel login-card fade-in${wide ? ' login-card-wide' : ''}`}>
        <div className="login-top">
          <Lockup />
          <LangToggle />
        </div>
        <div className="login-title">
          <h1 ref={h1} tabIndex={-1}>
            {title}
          </h1>
          {subtitle && <p className="text-muted">{subtitle}</p>}
        </div>
        {children}
      </main>
      <footer className="login-foot">
        <p>
          <Link to="/accessibility">{t['a11y.link']}</Link>
        </p>
      </footer>
    </div>
  );
}
